import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CollectionApiResponse } from '../../../lib/util/api-response';
import { RolleItem } from './rolle.model';
import {RechteItem} from './rechte.model';

type RolleResponse = CollectionApiResponse<RolleItem>;
type RechteResponse = CollectionApiResponse<RechteItem>;

@Injectable()
export class RolleService {
    /**
     * Constructor of SalutationsService
     *
     * @param httpClient - Http service of angular
     */
    constructor(private httpClient: HttpClient) {}

    /**
     * Get all salutations
     *
     * @returns - An observable that emits with the fetched salutations
     */

    public getAllRollen(): Observable<RolleResponse> {
      // tslint:disable-next-line:max-line-length
        return this.httpClient.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/getAll/getAllRollen.php?${sessionStorage.getItem('session')}`) as Observable<
          RolleResponse
        >;
    }

  public getAllRechte(): Observable<RechteResponse> {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/getAll/getAllRechte.php?${sessionStorage.getItem('session')}`) as Observable<
      RechteResponse
      >;
  }

  public getUserRollen(): Observable<RolleResponse> {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/rollenverwaltung/getUserRollen.php?${sessionStorage.getItem('session')}`) as Observable<
      RolleResponse
      >;
  }

  public changeRolle(rolleId: number): Observable<number> {
    return this.httpClient.get(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/rollenverwaltung/changeRolle.php?${sessionStorage.getItem('session')}&rolleId=${rolleId}`) as Observable<
      number
      >;
  }

  public addRolle(rolle: RolleItem): Observable<RolleItem> {
    return this.httpClient.post(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/rollenverwaltung/addRolle.php?${sessionStorage.getItem('session')}`, rolle) as Observable<
      RolleItem
      >;
  }

  public editRolle(rolle: RolleItem): Observable<RolleItem> {
    return this.httpClient.post(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/rollenverwaltung/editRolle.php?${sessionStorage.getItem('session')}`, rolle) as Observable<
      RolleItem
      >;
  }

  public deleteRolle(rolle: RolleItem): Observable<RolleItem> {
    return this.httpClient.post(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/rollenverwaltung/deleteRolle.php?${sessionStorage.getItem('session')}`, rolle) as Observable<
      RolleItem
      >;
  }
}
